import React, {Component} from 'react';

import 'sass/payment/PaymentOptionRadio.scss';
import {formatAmount} from '../../utils/payment';

import {t, dt} from 'l10n';

const PaymentOptionRadio = ({value, name, checked, price, freePoints, onSelect}) => (
    <div className={'radio-stylized payment-option-radio' + (checked ? ' selected' : '')} onClick={() => onSelect(value)}>
        <input type="radio" name="t" id={'payment-play-radio-'+value} value={value} checked={checked} readOnly/>
        <label htmlFor={'payment-play-radio-'+value}>{name} / <strong>{formatAmount(price)}</strong></label>
    </div>
);

export default PaymentOptionRadio;


// WEBPACK FOOTER //
// ./src/components/payment/PaymentOptionRadio.js